export default {
  "$white":    "#fffffff2",
  "$gray-100": "#ffffffb3",
  "$gray-200": "#ebebeb",
  "$gray-300": "#dee2e6",
  "$gray-400": "#ced4da",
  "$gray-500": "#93a4b5",
  "$gray-600": "#787e87",
  "$gray-700": "#393F46",
  "$gray-800": "#1C2126",
  "$gray-900": "#14191F",
  "$black": "#1c1c1c",

  "$blue": "#2D5286",
  "$indigo":  "#6610f2",
  "$purple":  "#6f42c1",
  "$pink":    "#e83e8c",
  "$red": "#BD3C28",
  "$orange":  "#d67b1f",
  "$yellow": "#D68F1F",
  "$green": "#1F9361",
  "$teal": "#20c9c3",
  "$cyan": "#24A8A8",

  "$primary":       "#2D5286",
  "$secondary":     "#787e87",
  "$success":       "#1F9361",
  "$info":          "#24A8A8",
  "$warning":       "#D68F1F",
  "$danger":        "#BD3C28",
  "$light":         "#93a4b5",
  "$dark":          "#1C2126",


  "$yiq-contrasted-threshold": 200,
  "$card-spacer-x": 0.75,
  "$font-family-sans-serif": [
    {
      "type": "SassString",
      "value": "Source Sans Pro"
    },
    {
      "type": "SassString",
      "value": "-apple-system"
    },
    {
      "type": "SassString",
      "value": "BlinkMacSystemFont"
    },
    {
      "type": "SassString",
      "value": "Segoe UI"
    },
    {
      "type": "SassString",
      "value": "Roboto"
    },
    {
      "type": "SassString",
      "value": "Helvetica Neue"
    },
    {
      "type": "SassString",
      "value": "Arial"
    },
    {
      "type": "SassString",
      "value": "sans-serif"
    },
    {
      "type": "SassString",
      "value": "Apple Color Emoji"
    },
    {
      "type": "SassString",
      "value": "Segoe UI Emoji"
    },
    {
      "type": "SassString",
      "value": "Segoe UI Symbol"
    }
  ],
  "$font-size-base": 1,
  "$dropdown-link-color": "#000000",
  "$nav-tabs-border-color": "#f0f0f0",
  "$nav-tabs-link-hover-border-color": "#f0f0f0",
  "$nav-tabs-link-active-color": "#222222",
  "$nav-tabs-link-active-border-color": "#f0f0f0",
  "$pagination-color": "#555555",
  "$pagination-bg": "#f0f0f0",
  "$pagination-hover-color": "#555555",
  "$pagination-hover-bg": "#f0f0f0",
  "$pagination-active-border-color": "#0c2ba2",
  "$pagination-disabled-color": "#999999",
  "$pagination-disabled-bg": "#f0f0f0",
  "$jumbotron-bg": "#fafafa",
  "$modal-content-border-color": "#000000",
  "$close-color": "#ffffff"
}
